//
//  burger-navbar.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import {Vue, Component, Prop} from 'vue-property-decorator';
import Navigation from '@/model/navigation';
import EventBus from '@/utils/event-bus';

@Component
export default class BurgerNavbar extends Vue {

    @Prop(String) private readonly context!: string;

    private get navigationItems(): Navigation[] {

        return [
            new Navigation(this, 'expertise', this.context, 0),
            new Navigation(this, 'demo', this.context, 1),
            new Navigation(this, 'moodreels', this.context, 2),
            new Navigation(this, 'customers', this.context, 3),
            new Navigation(this, 'about', this.context, 4),
            new Navigation(this, 'contact', this.context, 5),
        ];

    }

    /*
     * Go to section when click on menu.
     */
    private onNavigationItemClick(item: Navigation): void {

        EventBus.$emit('go-to-item', item);
        this.$emit('close');

    }

    private returnToHome(): void {

        EventBus.$emit('return-to-home');
        this.$emit('close');

    }

}
